var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 444,
    viewBox: "0 0 444 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444 222C444 344.607 344.607 444 222 444C99.3928 444 0 344.607 0 222C0 99.3928 99.3928 0 222 0C344.607 0 444 99.3928 444 222ZM330.292 172.434C330.292 190.16 315.921 204.53 298.195 204.53C280.469 204.53 266.099 190.16 266.099 172.434C266.099 154.707 280.469 140.337 298.195 140.337C315.921 140.337 330.292 154.707 330.292 172.434ZM147.665 203.53C165.391 203.53 179.761 189.16 179.761 171.434C179.761 153.707 165.391 139.337 147.665 139.337C129.939 139.337 115.569 153.707 115.569 171.434C115.569 189.16 129.939 203.53 147.665 203.53ZM220.765 307.221C221.686 307.234 222.643 307.241 223.636 307.241C267.978 307.241 276.898 316.888 286.585 327.365C288.25 329.165 289.937 330.99 291.83 332.795C292.359 333.298 292.983 333.693 293.677 333.92C297.041 335.021 307.312 337.623 305.274 327.546C302.865 315.634 288.761 290.467 223.754 288.148C223.656 288.112 223.605 288.094 223.605 288.094C223.346 288.101 223.087 288.109 222.829 288.117C222.579 288.109 222.328 288.101 222.076 288.094C222.076 288.094 222.029 288.112 221.937 288.146C155 290.449 140.48 315.598 138 327.5C135.895 337.603 146.55 334.947 149.971 333.855C150.658 333.635 151.281 333.253 151.811 332.763C153.768 330.954 155.51 329.125 157.229 327.32L157.23 327.32C167.107 316.949 176.208 307.394 220.765 307.221Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.0ba57946103cef44160fd22090061cf5.svg";
export { ForwardRef as ReactComponent };